import { QuizActionButton } from "@/components/storyboard/quiz/QuizActionButton";

interface QuizCheckNextActionProps {
  isSubmitted: boolean;
  hasNextQuestion: boolean;
  canSubmit: boolean;
  onSubmit: () => void;
  onNext: () => void;
  /** Replaces „Überprüfen“ when the quiz stores the answer without a verdict. */
  submitLabel?: string;
}

/**
 * Überprüfen, then Nächste Frage when another entry remains — used by
 * multi-entry quizzes that share that two-step footer.
 */
const QuizCheckNextAction = ({
  isSubmitted,
  hasNextQuestion,
  canSubmit,
  onSubmit,
  onNext,
  submitLabel = "Überprüfen",
}: QuizCheckNextActionProps) => {
  if (!isSubmitted) {
    return (
      <QuizActionButton
        variant="default"
        onClick={onSubmit}
        disabled={!canSubmit}
      >
        {submitLabel}
      </QuizActionButton>
    );
  }

  if (hasNextQuestion) {
    return <QuizActionButton onClick={onNext}>Nächste Frage</QuizActionButton>;
  }

  return null;
};

export default QuizCheckNextAction;
